
angular.module('mtic.components.modules.qcModule').component('qcModuleChild', {
  templateUrl: 'template.html',
  bindings: {
    resources: '<'
  },
  controllerAs: 'qcModule',
  controller: function(EventManager, $scope) {
    var eventManager = new EventManager('qcModule', $scope);
    var qcModule = this;
    qcModule.openResource = function(resource) {
      eventManager.broadcast('module:open:resource', resource)
    }
    qcModule.hasChildren = function(resource) {
      return resource.children ? resource.children.length > 0 : false;
    }
  }
})
